import TiktokPixel from "tiktok-pixel";
import { fetch_cloud_function } from "../FetchCloudFunction/FetchCloudFunction"
import { generateFirebaseId } from "../Helpers/generateAFirebaseId"
import { storeData } from "../storeData";
// import { updateStockOutlet } from "../Scripts/updateStockOutlet";
import { localstorageCRUD } from "../Scripts/localstorageCRUD";
import { initializeFSTORE3 } from "../Scripts/initializeFSTORE3";
import { doc, getDoc, collection, query, where, getDocs, limit } from "firebase/firestore";
import { clean_customer_phone } from "../Helpers/clean_customer_phone";
import { SHIPPING_OPTIONS } from "../Layouts/Layouts_PurchaseForm/ShippingTypeSelector/ShippingTypeSelector";

export const createOrderAsShopify = async (user_data, cart_items, asDraft, asUpsell, upsellProductData, upsellItem, upsellPageData, selectedVariantsForUpsellItem, UTM_params, discount_code, free_shipping, shipping_cost, shipping_type_code) => {
    // console.log("cart_items", cart_items)

    let CustomLineItems = cart_items.map(item => buildLineItems(item.selectedVariants, item.ProductData, item.selectedPackData, false)).flat();
    let CustomUpsellItem = null;
    let definitive_custom_items = CustomLineItems;
    if(asUpsell === true){
        CustomUpsellItem = buildLineItems(selectedVariantsForUpsellItem, upsellProductData, upsellItem, true);
        definitive_custom_items = CustomLineItems.concat(CustomUpsellItem);
    }

    let aux_total_price = definitive_custom_items.reduce((total, item) => total + (item.price * item.quantity), 0);

    let checkoutId = window.checkoutId;
    let note_attributes = UTM_params ? [...UTM_params] : [];
    if(discount_code){
        note_attributes.push({ name: "Codigo descuento", value: discount_code });
    }
    note_attributes = [
        ...note_attributes,
        {name: "_insu_d", value: null},
        {name: "_insu_d_vfp", value: null},
        {name: "_insu_d_fv", value: null},
        {name: "_insu_d_lv", value: null},

        {name: "_insu_d_o_time_dif_first", value: null},
        {name: "_insu_d_o_time_dif", value: null},
        {name: "_timeDiff_lv_start_typing_form", value: null},
        {name: "_timeDiff_start_end_typing_first_name", value: null},

        {name: "_fip_scC", value: null},
        {name: "_fip_scCT", value: null},

        // {name: "_insu_d", value: _insu_d ?? null},
        // {name: "_insu_d_vfp", value: _insu_d_vfp ?? null},
        // {name: "_insu_d_fv", value: _insu_d_fv ?? null},
        // {name: "_insu_d_lv", value: _insu_d_lv ?? null},

        // {name: "_insu_d_o_time_dif_first", value: _insu_d_o_time_dif_first ?? null},
        // {name: "_insu_d_o_time_dif", value: _insu_d_o_time_dif ?? null},
        // {name: "_timeDiff_lv_start_typing_form", value: _timeDiff_lv_start_typing_form ?? null},
        // {name: "_timeDiff_start_end_typing_first_name", value: _timeDiff_start_end_typing_first_name ?? null},

        // {name: "_fip_scC", value: _fip_scC ?? null},
        // {name: "_fip_scCT", value: _fip_scCT ?? null},
    ]

    const ip = await getIp();
    const shipping_discounted_price = SHIPPING_OPTIONS?.find(option => option.code === shipping_type_code)?.price || 0;

    let shopifyObj = {
        isFKOrder: false,
        note_attributes: note_attributes,
        isComodinOrder: true,
        comodinIdStore: storeData().comodinIdStore,
        comodinName: storeData().name,
        checkoutId,
        asDraft: asDraft===true?true:false,
        asUpsell: asUpsell===true?true:false,
        browser_ip: ip?? "NO_IP",
        client_details: {
            browser_height: "",
            browser_width: "",
            user_agent: "",
            session_hash: "",
            accept_language: "",
        },
        line_items: definitive_custom_items,
        order_number: asUpsell ? upsellPageData.order_number : "",
        note: user_data.note,
        shipping_address: {
            first_name: user_data.first_name,
            last_name: user_data.last_name,
            address1: user_data.address1,
            address2: user_data.address2,
            zip: "",
            city: user_data.city,
            province: user_data.province,
            name: `${user_data.first_name} ${user_data.last_name}`,
            phone: user_data.phone_number,
        },
        contact_email: user_data.contact_email,
        total_price: aux_total_price,
        total_discounts: 0,
        gateway: "Cash On Delivery (COD)",
        shipping_lines: [
            {
                code: shipping_type_code || "Normal", // "Rápido con proposito"
                // discounted_price: free_shipping? 0 : shipping_cost,
                discounted_price: shipping_discounted_price > 0 ? shipping_discounted_price : free_shipping? 0 : shipping_cost,
            }
        ],
    }

    const IS_FOOL = await FKFilter(shopifyObj);
    shopifyObj.isFKOrder = IS_FOOL;

    // console.log("asDraft::::::::::::::::::::: ->",asDraft)
    // console.log("shopifyObj:::::::::::::::::: ->", shopifyObj)
    let res = await sendOrder(shopifyObj, asDraft, asUpsell);
    return res;
}

export const sendOrder = async (shopifyObj, asDraft, asUpsell) => {

    if(asDraft!==true && asUpsell!==true && shopifyObj.isFKOrder !== true){
        window.fbq('track', 'Purchase', {currency: "COP", value: shopifyObj.total_price});
        TiktokPixel.track('CompletePayment', {
            content_type: 'product',
            content_id: shopifyObj.checkoutId,
            currency: 'COP',
            value: shopifyObj.total_price,
        });
    }

    // BORRAR - PRUEBAS LOCAL
    // await updateStockOutlet(shopifyObj)
    // BORRAR - PRUEBAS LOCAL

    let res = await fetch_cloud_function(asDraft===true?"https://us-central1-comodin-c9ec5.cloudfunctions.net/app/api/enviar-borrador":"https://us-central1-comodin-c9ec5.cloudfunctions.net/app/api/enviar-pedido",shopifyObj)
    if(res.success === true && asDraft!==true && asUpsell!==true){
        localstorageCRUD().delete("cart_items") 
        // await updateStockOutlet(shopifyObj)
    }
    return res
}

const buildLineItems = (selectedVariants, product_data, order_data, isUpsell) => {
    return selectedVariants.map((variant, index) => {
        let sku_img = product_data.productVariations.find(variation => variation.variation_sku === variant.sku)?.variation_img_src || "";
        return {
            grams: 1000,
            product_id: product_data.product_inside_id,
            title: product_data.comodin_title,
            variant_title: variant.variant_title,
            sku: variant.sku,
            // quantity: order_data.quantity,
            quantity: 1,
            price: order_data.unitary_price,
            discount_allocations: [],
            id: isUpsell ? "upsell" + index : index.toString(),
            name: product_data.comodin_title,
            vendor: "Comodin",
            isUpsell: isUpsell,
            sku_img: sku_img,
        };
    });
}

const FKFilter = async (shopifyObj) => {
  const db = initializeFSTORE3();
  const ordersCol = collection(db, "fk_orders");

  // Extraemos los campos a chequear
  const rawPhone = shopifyObj.shipping_address.phone || "NOTHING";
  const cleanedPhone = rawPhone!=="NOTHING"? clean_customer_phone(rawPhone) : "NOTHING";
  const email = shopifyObj.contact_email || "NOTHING";
  const browserIp = shopifyObj.browser_ip || "NOTHING";

  // Función auxiliar que revisa si existe al menos un doc con field == value
  const exists = async (field, value) => {
    if (!value) return false;
    const q = query(ordersCol, where(field, "==", value), limit(1));
    const snap = await getDocs(q);
    return !snap.empty;
  };

  // Ejecutamos las comprobaciones en serie
  if (
    await exists("cleaned_customer_phone", cleanedPhone) ||
    await exists("contact_email", email) ||
    await exists("browser_ip", browserIp)
  ) {
    // Ya existe un pedido con alguno de estos datos
    return true;
  }

  // No se encontró duplicado
  return false;
};


const getIp = async () => {
    try {
        const response = await fetch('https://api.ipify.org?format=json');
        const data = await response.json();
        const browser_ip = data.ip;
        return browser_ip;
    } catch (error) {
        return null;
    }
};

